<header class="header">
  <div class="header-container">
    <div class="header-logo">
      <a [routerLink]="['']" class="header-logo-link">
        <img src="assets/images/logo.svg" alt="logo" height="36" width="116">
      </a>
    </div>
  </div>
</header>
